import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import ContactInfo from './section-components/contact-info';
import Map from './section-components/map';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import { useLang } from '../i18n/LanguageContext';

const ContactV1 = () => {
    const { t } = useLang();
    return <div>
        <Navbar />
        <PageHeader headertitle={t('pageTitles.contact')} subheader={t('pageTitles.contact')} />
        <ContactInfo />

        <CallToActionV1 />
        <Footer />
    </div>
}

export default ContactV1

